import React from "react";

import { TeamLineupsPlayerInfo } from "@data-types/sport-stats/SportStatsTypes";
import TeamLineupsStore from "@state/stores/offer/statistics/TeamLineupsStore";
import classnames from "classnames";
import { observer } from "mobx-react";

export default observer(function TeamLineupsSubstitutions(props: {
    substitutionPlayers: TeamLineupsPlayerInfo;
    store: TeamLineupsStore;
}) {
    const stats = props.substitutionPlayers || {};
    const playerGoals = Number(stats.goals);
    const playerAssists = Number(stats.statistics?.summary?.assists ?? 0);
    const playerOwnGoals = Number(stats.ownGoals);
    const rating = stats?.rating ?? 0;

    const playerCard = (yellowCard?: number, redCard?: number) => {
        if (yellowCard === 1 && redCard !== 1) {
            return (
                <i className="u-icon u-icon--xsml u-icon--card u-icon--card--rotate u-icon--card--yellow" />
            );
        } else if (redCard === 1 || (yellowCard === 1 && redCard === 1)) {
            return (
                <i className="u-icon u-icon--xsml u-icon--card u-icon--card--rotate u-icon--card--red" />
            );
        } else if (yellowCard === 2) {
            return (
                <i className="u-icon u-icon--xsml u-icon--card u-icon--card--combined" />
            );
        }
    };

    const counterClassName = classnames(
        "statistics--player__tag tag tag--med tag--rating",
        `tag--rating--${props.store.colorGradient(rating)}`
    );

    return (
        <tr className="table__body__tr table__row">
            <td className="table__body__cell table__cell">
                <div className="u-display--f u-gap--3">
                    <div className="statistics--player__jersey">
                        <div className="statistics--player__number">
                            {props.substitutionPlayers.jerseyNumber}
                        </div>
                    </div>

                    <div className="statistics--player__title">
                        <div className="statistics--player__team w--100--max">
                            <div
                                className="statistics--player__name"
                                title={props.substitutionPlayers.name}
                            >
                                {props.substitutionPlayers.name}
                            </div>
                        </div>

                        <div className="statistics--player__info">
                            {props.substitutionPlayers.substitute &&
                            Number(
                                String(
                                    props.substitutionPlayers.statistics
                                        ?.summary?.minutesPlayed || ""
                                ).replace("'", "")
                            ) > 0 ? (
                                <i className="u-icon u-icon--xsml u-icon--substitute" />
                            ) : null}

                            {playerGoals > 0 && (
                                <div className="statistics--player__goal">
                                    <i className="u-icon u-icon--xsml u-icon--goal" />
                                    <span>
                                        {(playerGoals ?? 0) > 1
                                            ? (playerGoals ?? 0)
                                            : ""}
                                    </span>
                                </div>
                            )}

                            {playerAssists > 0 && (
                                <div className="statistics--player__goal">
                                    <i className="u-icon u-icon--xsml u-icon--assists" />
                                    <span>
                                        {(playerAssists ?? 0) > 1
                                            ? (playerAssists ?? 0)
                                            : ""}
                                    </span>
                                </div>
                            )}

                            {playerOwnGoals > 0 && (
                                <div className="statistics--player__goal">
                                    <i className="u-icon u-icon--xsml u-icon--own-goal" />
                                    <span>
                                        {playerOwnGoals > 1
                                            ? playerOwnGoals
                                            : ""}
                                    </span>
                                </div>
                            )}

                            {playerCard(
                                props.substitutionPlayers.yellowCard,
                                props.substitutionPlayers.redCard
                            )}
                        </div>
                    </div>

                    {stats?.rating !== undefined && stats.rating !== 0.0 ? (
                        <span className={counterClassName}>
                            {stats.rating.toFixed(1)}
                        </span>
                    ) : (
                        <span className="statistics--player__tag tag tag--med tag--rating tag--rating--none">
                            -
                        </span>
                    )}
                </div>
            </td>
        </tr>
    );
});
